import * as Zod from 'zod';

export const apartmentScheme = Zod.object({
  id: Zod.number(),
  label: Zod.string(),
});
